import { Observable } from 'rxjs';

import { RequestResponse } from '@shure/shared/angular/data-access/system-api/models';

import { RoomAdaptDevice, RoomAdaptRoomDevice } from './models';

export abstract class RoomAdaptApiService {
	/**
	 * Get room adapt device by id.
	 */
	public abstract getDevice$(deviceId: string): Observable<RoomAdaptDevice>;

	/**
	 * Get list of devices in a room and whether each supports room characterization.
	 */
	public abstract getDevicesInRoom$(roomId: string): Observable<RoomAdaptRoomDevice[]>;

	/**
	 * Get the ids of all currently discovered devices that support room characterization.
	 */
	public abstract getAllRoomAdaptDeviceIds$(): Observable<string[]>;

	/**
	 * Start room adapt on the device.
	 */
	public abstract startRoomAdapt(deviceId: string): Observable<RequestResponse<string>>;

	/**
	 * Abort an in-progress room adapt process.
	 */
	public abstract abortRoomAdapt(deviceId: string): void;

	/**
	 * Get the gzipped base64-encoded ARCC report, or null if unavailable.
	 */
	public abstract retrieveRoomCharacterizationReport(deviceId: string): Observable<string | null>;
}
